module.exports = __webpack_public_path__ + "static/img/bank0-1.695571d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/bank0-1.png
// module id = ufKh
// module chunks = 1